import Vuetify from 'vuetify';
import VueProgressBar from 'vue-progressbar';
import VueFroala from 'vue-froala-wysiwyg';
import vuetifyOptions from './options/vuetify';
import progressBarOptions from './options/progressBar';
import '../plugins/froala-import';

import { use } from '../framework';

const VueMoment = require('vue-moment');

export default {
  install(Vue) {
    use(Vue, [
      [Vuetify, vuetifyOptions],
      [VueProgressBar, progressBarOptions],
      VueMoment,
      VueFroala,
    ]);
  },
};



// WEBPACK FOOTER //
// ./src/plugins/index.js